import { createFullCycleActions, createMiddlewares } from 'utils/actions'
import _ from 'lodash'
import update from 'immutability-helper'
import toastr from '@zanroo/react-redux-toastr-arun'
import * as apis from 'apis/cms/interest-tag'

const Actions = {
  settings: createFullCycleActions({
    prefix: 'actions.cms.interest_tag.settings',
    customMiddlewares: (actions) => ({
      list: createMiddlewares({
        caller: apis.LIST,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          await dispatch(actions.default.set(data))
        }
      }),
      create: createMiddlewares({
        caller: apis.CREATE,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          const state = getState()
          const defaultData = _.get(state, 'cms.interest_tag.settings.default', {})
          const updated = update(defaultData, {
            items: {
              $push: [data]
            }
          })

          await dispatch(actions.default.set(updated))

          toastr.success('SUCCESS', 'Setting has been created.')
        }
      }),
      update: createMiddlewares({
        caller: apis.UPDATE,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          const state = getState()
          const defaultData = _.get(state, 'cms.interest_tag.settings.default', {})

          const index = _.findIndex(defaultData.items, { _id: data._id })

          if (index < 0) {
            return
          }

          const updated = update(defaultData, {
            items: {
              [index]: { $set: data }
            }
          })

          await dispatch(actions.default.set(updated))
          toastr.success('SUCCESS', 'Setting has been updated.')
        }
      }),
      del: createMiddlewares({
        caller: apis.DELETE,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          const state = getState()
          const defaultData = _.get(state, 'cms.interest_tag.settings.default', {})
          const index = _.findIndex(defaultData.items, { _id: data._id })

          if (index < 0) {
            return
          }

          const updated = update(defaultData, {
            items: { $splice: [[index, 1]] }
          })

          await dispatch(actions.default.set(updated))
          toastr.success('SUCCESS', 'Setting has been deleted.')
        }
      })
    })
  })
}

export default Actions
